module.exports = __webpack_public_path__ + "static/media/repair-ne.22623bd1.svg";